import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.company.name();
  },

  city() {
    return faker.address.city();
  },

  cityEn() {
    return `${this.city} EN`;
  },

  street() {
    return faker.address.street();
  },

  zipcode() {
    return faker.address.zipCode('#####');
  },

  phone() {
    return faker.phone.number('+49 ## #### ####');
  },

  email() {
    return faker.internet.email(this.name);
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(tradePartner, server) {
    let numTradeTypes = faker.datatype.number({
      min: 1,
      max: 2,
    });

    tradePartner.update({
      country: server.create('category', 'country'),
      link: server.create('link'),
      partnerType: server.create('category', 'partnerTypeTrade'),
      region: server.create('category', 'region'),
      tradeTypes: server.createList(
        'category',
        numTradeTypes,
        'partnerTypeOnOff',
      ),
    });
  },
});
